import jwtDecode from 'jwt-decode'
function getQueryParams() {
  const url = window.location.href
  const queryParams = url.split('?')[1]
  const params = queryParams ? queryParams.split('&') : []

  const paramsObject = {}

  for (const param of params) {
    const [key, val] = param.split('=')
    paramsObject[key] = val
  }

  return paramsObject
}

function checkTokeninQueryParams(params) {
  return params.token ? params.token : false
}

export function setItem(key, value, storageType = 'TEMPORARY') {
  if (storageType === 'PERSISTENT') {
    localStorage.setItem(key, value)
  } else {
    sessionStorage.setItem(key, value)
  }
}

export async function checkTokenAuth() {
  const params = getQueryParams()

  const token = checkTokeninQueryParams(params)

  const isDemo = Boolean(params.demo)

  if (token) {
    try {
      const payload = jwtDecode(token)
      const loginId = payload.loginId
      const username = payload.username
      setItem('loginId', loginId, 'TEMPORARY')
      setItem('username', username, 'TEMPORARY')
      setItem('token', token, 'TEMPORARY')
      setItem('loginType', 'TOKEN', 'TEMPORARY')

      if (isDemo) {
        setItem('isDemo', 'true', 'TEMPORARY')
      }

      window.location.replace(window.location.href.split('?')[0])
    } catch (e) {}
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js